import * as React from "react";
import { H1, Label, LoadingSpinner, Select, Table, Text } from "atoms";
import { Head } from "features/misc";
import { useAllRaffleItems } from "features/pointsStore";
import { useRaffleReport } from "../api/useRaffleReport";

const REPORT_HEADINGS = ["Raffle Id", "User Id", "Name", "Email"];

function RaffleReport() {
  const { data: raffles, isLoading: areRafflesLoading } = useAllRaffleItems();
  const [raffleId, setRaffleId] = React.useState<string | undefined>();
  const { data, isLoading } = useRaffleReport(raffleId);

  const showReport = data && !isLoading;

  if (areRafflesLoading || !raffles) {
    return (
      <main>
        <Head title="Curator Reports | Admin" />
        <LoadingSpinner />
      </main>
    );
  }

  return (
    <main>
      <Head title="Curator Reports | Admin" />

      <Label>
        Select Raffle
        <Select onChange={(e) => setRaffleId(e.target.value)}>
          <option value="">-</option>
          {raffles.map((r) => (
            <option key={r.id} value={r.id}>
              {r.title}
            </option>
          ))}
        </Select>
      </Label>

      <H1>Raffle Report: {raffleId}</H1>

      {showReport ? (
        <Table>
          <thead>
            <tr>
              <th>{REPORT_HEADINGS[0]}</th>
              <th>{REPORT_HEADINGS[1]}</th>
              <th>{REPORT_HEADINGS[2]}</th>
              <th>{REPORT_HEADINGS[3]}</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((row) => (
              <tr key={`${row.raffleId}-${row.userId}`}>
                <td>{row.raffleId}</td>
                <td>{row.userId}</td>
                <td>{row.name}</td>
                <td>{row.email}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Text>
          <em>
            {raffleId ? "Loading..." : "Choose a raffle to see the report"}
          </em>
        </Text>
      )}
    </main>
  );
}

export { RaffleReport };
